const sessionStorageService = {
  /**
   * Save an item to sessionStorage.
   * @param {string} key - The key under which the value should be stored.
   * @param {*} value - The value to be stored. It will be stringified to JSON.
   */
  setItem: (key, value) => {
    try {
      const serializedValue = JSON.stringify(value);
      sessionStorage.setItem(key, serializedValue);
    } catch (error) {
      console.error("Error saving to sessionStorage", error);
    }
  },

  /**
   * Retrieve an item from sessionStorage.
   * @param {string} key - The key of the item to retrieve.
   * @returns {*} - The parsed JSON value, or null if the key doesn't exist.
   */
  getItem: (key) => {
    try {
      const serializedValue = sessionStorage.getItem(key);
      return serializedValue ? JSON.parse(serializedValue) : null;
    } catch (error) {
      console.error("Error retrieving from sessionStorage", error);
      return null;
    }
  },

  /**
   * Remove an item from sessionStorage.
   * @param {string} key - The key of the item to remove.
   */
  removeItem: (key) => {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      console.error("Error removing from sessionStorage", error);
    }
  },

  /**
   * Clear all items from sessionStorage.
   */
  clear: () => {
    try {
      sessionStorage.clear();
    } catch (error) {
      console.error("Error clearing sessionStorage", error);
    }
  },
};

export default sessionStorageService;
